export const categories = [
  { slug: 'jijian-hufu', name: '极简护肤', description: '回归护肤本质，用最少的步骤获得最佳效果', icon: 'ri-drop-line' },
  { slug: 'luoji-yanghu', name: '裸肌养护', description: '唤醒肌肤自愈力，打造天然健康肌底', icon: 'ri-heart-pulse-line' },
  { slug: 'suyan-jiqiao', name: '素颜技巧', description: '无需浓妆，展现自然透亮的好气色', icon: 'ri-sun-line' },
  { slug: 'chengfen-jiexi', name: '成分解析', description: '读懂成分表，科学选择护肤产品', icon: 'ri-flask-line' },
  { slug: 'hufu-wuqu', name: '护肤误区', description: '避开常见陷阱，让护肤不再走弯路', icon: 'ri-error-warning-line' },
  { slug: 'jijie-hufu', name: '季节护肤', description: '随季应变，给肌肤最合时宜的呵护', icon: 'ri-calendar-check-line' },
];

export const articles = [
  {
    slug: 'quanluo-hufu-kexue-yuanli',
    title: '全裸护肤的科学原理：为什么"少即是多"在护肤中成立',
    excerpt: '深入了解皮肤屏障的工作机制，揭开极简护肤背后的科学真相。从表皮微生态到角质层健康，为什么减少护肤品反而能让肌肤状态更好？',
    category: 'jijian-hufu',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20skincare%20science%20concept%20with%20clean%20glass%20bottles%20and%20natural%20botanical%20elements%20on%20a%20soft%20beige%20background%2C%20warm%20natural%20lighting%2C%20editorial%20photography%2C%20elegant%20composition&width=800&height=500&seq=article-science-01&orientation=landscape',
    author: '林清悦',
    date: '2026-08-10',
    readTime: '8 分钟',
    tags: ['皮肤屏障', '极简护肤', '科学护肤'],
    featured: true,
    content: `
      <h2>皮肤屏障：你的天然保护膜</h2>
      <p>皮肤屏障是人体最大的器官——皮肤的最外层防线。它由角质细胞和细胞间脂质构成，像一面砖墙一样保护着我们的身体。当我们过度使用护肤品，尤其是含有刺激性成分的产品时，这面"墙"就会被逐渐破坏。</p>
      
      <h3>屏障受损的三大信号</h3>
      <p>当你的皮肤出现以下状况时，很可能屏障已经受损：紧绷感持续不退、泛红敏感频繁出现、外油内干状态明显。这些都是皮肤在向你发出求救信号。</p>
      
      <h2>极简护肤的核心理念</h2>
      <p>全裸护肤并非什么都不用，而是精准选择肌肤真正需要的成分。核心原则只有三个字：清、护、防——清洁、保湿、防晒。这三步构成了最基础的护肤闭环。</p>
      
      <h3>减法哲学在护肤中的应用</h3>
      <p>每增加一个产品，就增加了一份致敏风险。研究显示，使用超过5种护肤品的女性，皮肤敏感发生率比使用3种以下的女性高出67%。这不是巧合，而是皮肤微生态被过度干预的必然结果。</p>
      
      <h2>科学验证：少即是多</h2>
      <p>日本皮肤科学会的一项研究追踪了200名采用极简护肤方案的女性，8周后，她们的经皮水分流失率平均下降了34%，皮肤泛红指数降低了28%。这些数据有力地证明了精简护肤方案的有效性。</p>
      
      <p>关键在于，当皮肤不再需要应对大量外来成分时，它会重新启动自我修复机制。角质层的更新周期约为28天，给予足够的时间和空间，皮肤有能力自行恢复健康状态。</p>
    `
  },
  {
    slug: 'luoji-diji-yanghu-buzhou',
    title: '裸肌底养护完整指南：从清洁到防护的四步法则',
    excerpt: '掌握裸肌养护的核心步骤，从温和清洁到深层修护，每一步都是对肌肤的温柔呵护。',
    category: 'luoji-yanghu',
    image: 'https://readdy.ai/api/search-image?query=Clean%20skincare%20routine%20with%20natural%20ingredients%20on%20a%20minimal%20wooden%20surface%2C%20soft%20morning%20light%2C%20serene%20aesthetic%2C%20editorial%20photography&width=800&height=500&seq=article-guide-02&orientation=landscape',
    author: '陈素心',
    date: '2026-08-08',
    readTime: '6 分钟',
    tags: ['裸肌养护', '护肤步骤', '日常护理'],
    featured: true,
    content: `
      <h2>第一步：温和清洁</h2>
      <p>清洁是护肤的基础，但过度清洁却是伤害皮肤的开始。选择pH值在5.5-6.0之间的氨基酸洁面产品，水温控制在32-34℃，每次清洁时间不超过60秒。</p>
      
      <h3>晨间清洁 vs 晚间清洁</h3>
      <p>早晨只需用清水或极少量洁面产品洗去夜间分泌的油脂即可。晚间则需要用温和洁面彻底清除一天的灰尘和防晒产品。记住：干净不等于紧绷，洗后皮肤应该是柔软舒适的。</p>
      
      <h2>第二步：精准保湿</h2>
      <p>保湿不是越厚重越好。根据肤质选择：油性肌肤选择凝胶质地，干性肌肤选择乳霜质地，混合性肌肤采用分区护理策略。核心成分推荐：神经酰胺、角鲨烷、泛醇。</p>
      
      <h2>第三步：定向修护</h2>
      <p>在保湿之后，根据肌肤的具体需求添加修护步骤。含有积雪草提取物、依克多因或蓝铜胜肽的精华可以帮助加速屏障修护。注意：一次只用一个修护类产品。</p>
      
      <h2>第四步：严格防晒</h2>
      <p>防晒是护肤中最不可省略的一步。紫外线导致的"光老化"占皮肤老化因素的80%以上。选择SPF30以上、PA+++的防晒产品，每天使用，阴天也不例外。</p>
    `
  },
  {
    slug: 'suyan-dadi-jiqiao',
    title: '素颜打底技巧：五分钟打造透亮裸肌感',
    excerpt: '不需要厚重的底妆，学会这些素颜打底技巧，让你的肌肤自然散发健康光泽。',
    category: 'suyan-jiqiao',
    image: 'https://readdy.ai/api/search-image?query=Natural%20beauty%20concept%20with%20minimal%20makeup%20products%20and%20fresh%20healthy%20skin%20texture%2C%20soft%20natural%20light%2C%20clean%20aesthetic%2C%20editorial%20photography&width=800&height=500&seq=article-bareface-03&orientation=landscape',
    author: '王美琳',
    date: '2026-08-06',
    readTime: '5 分钟',
    tags: ['素颜', '打底技巧', '裸妆'],
    featured: false,
    content: `
      <h2>素颜打底的核心思路</h2>
      <p>素颜打底的目的不是遮盖，而是提亮和均匀肤色。关键是通过妆前护理和轻薄产品，让肌肤呈现"天生好皮"的效果。记住：好的皮肤状态胜过任何粉底液。</p>
      
      <h2>五分钟素颜打底流程</h2>
      <h3>第1-2分钟：妆前保湿打底</h3>
      <p>取适量保湿霜全脸涂抹，重点按压两颊和额头，让皮肤充分吸收。这一步能确保后续产品服帖不卡粉。</p>
      
      <h3>第3分钟：防晒+提亮</h3>
      <p>选择带有轻微润色效果的防晒产品，既能防护紫外线，又能均匀肤色。用手指点涂然后拍开，比用美妆蛋更自然。</p>
      
      <h3>第4-5分钟：局部修饰</h3>
      <p>用遮瑕膏点涂在需要修饰的部位——眼下暗沉、鼻翼泛红、痘印等。最后用散粉轻轻定妆T区和眼下，保持清爽感。</p>
    `
  },
  {
    slug: 'shenjingxianan-chengfen-jiexi',
    title: '神经酰胺、角鲨烷、泛醇：三大修护成分深度对比',
    excerpt: '市面上修护成分众多，神经酰胺、角鲨烷和泛醇各有什么特点？哪种最适合你的肤质？',
    category: 'chengfen-jiexi',
    image: 'https://readdy.ai/api/search-image?query=Skincare%20ingredient%20analysis%20with%20laboratory%20glassware%20and%20natural%20botanicals%20on%20a%20clean%20marble%20surface%2C%20scientific%20yet%20elegant%20aesthetic%2C%20warm%20lighting&width=800&height=500&seq=article-ingredients-04&orientation=landscape',
    author: '林清悦',
    date: '2026-08-05',
    readTime: '7 分钟',
    tags: ['神经酰胺', '角鲨烷', '泛醇', '成分解析'],
    featured: true,
    content: `
      <h2>神经酰胺：屏障之砖</h2>
      <p>神经酰胺占皮肤角质层脂质的50%以上，是维持屏障功能的核心成分。它像砖块之间的水泥，将角质细胞紧密连接在一起。缺乏神经酰胺会导致皮肤干燥、敏感和加速老化。</p>
      
      <h3>适用肤质</h3>
      <p>所有肤质均可使用，尤其是干性、敏感性和老化肌肤。神经酰胺与皮肤本身的成分高度相似，几乎不存在不耐受的问题。</p>
      
      <h2>角鲨烷：轻盈锁水</h2>
      <p>角鲨烷是角鲨烯的氢化稳定版本，也是人体皮脂的天然组成部分。它的分子量小、渗透快，能在皮肤表面形成透气保护膜，锁住水分的同时不堵塞毛孔。</p>
      
      <h3>适用肤质</h3>
      <p>油性、混合性和痘痘肌的理想选择。质地轻盈不油腻，即使夏季使用也不会有负担感。</p>
      
      <h2>泛醇（维生素B5）：全能修护</h2>
      <p>泛醇的分子量极小，能渗透到皮肤深层，在体内转化为泛酸（维生素B5），参与细胞能量代谢。它具有卓越的保湿、修护和抗炎功效。</p>
      
      <h3>适用肤质</h3>
      <p>所有肤质，尤其适合受损皮肤、医美术后修复和晒后舒缓。</p>
    `
  },
  {
    slug: 'changjian-hufu-wuqu',
    title: '5个最常见的护肤误区，你可能每天都在犯',
    excerpt: '从"越贵越好"到"天天敷面膜"，这些流传已久的护肤误区，正在悄悄伤害你的皮肤。',
    category: 'hufu-wuqu',
    image: 'https://readdy.ai/api/search-image?query=Common%20skincare%20mistakes%20illustrated%20with%20crossed%20out%20product%20bottles%20on%20a%20soft%20pink%20background%2C%20educational%20concept%2C%20clean%20minimal%20design&width=800&height=500&seq=article-mistakes-05&orientation=landscape',
    author: '陈素心',
    date: '2026-08-03',
    readTime: '5 分钟',
    tags: ['护肤误区', '护肤常识', '避坑指南'],
    featured: false,
    content: `
      <h2>误区一：越贵的产品效果越好</h2>
      <p>价格不等于效果。很多高价产品的成本主要花在品牌营销和包装上，而非有效成分。学会看成分表，找到适合自己肤质的产品，比盲目追求大牌更重要。</p>
      
      <h2>误区二：天天敷面膜皮肤会变好</h2>
      <p>面膜属于密集护理产品，一周使用2-3次足矣。过度敷面膜会导致皮肤过度水合，破坏角质层结构，反而让皮肤变得更脆弱敏感。</p>
      
      <h2>误区三：出油是因为缺水</h2>
      <p>皮肤出油主要受激素和遗传因素影响，与"缺水"没有直接因果关系。油性肌肤同样需要保湿，但选择清爽质地的产品即可，不需要疯狂补水。</p>
      
      <h2>误区四：天然的就是安全的</h2>
      <p>柠檬汁、小苏打、椰子油等"天然"成分直接上脸，可能带来严重的皮肤刺激。天然 ≠ 安全，化学成分 ≠ 有害。关键看成分的安全性和皮肤耐受度。</p>
      
      <h2>误区五：防晒只需要夏天涂</h2>
      <p>紫外线中的UVA全年强度变化不大，可以穿透云层和玻璃。一年四季、室内室外都需要防晒。这是抗衰老最有效、最便宜的方法。</p>
    `
  },
  {
    slug: 'dongji-jijian-hufu-fangan',
    title: '冬季极简护肤方案：抵御干燥的三种核心策略',
    excerpt: '冬季干燥寒冷对皮肤是严峻考验，掌握极简却高效的冬季护肤方案，让肌肤安然过冬。',
    category: 'jijie-hufu',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20winter%20skincare%20concept%20with%20cream%20textures%20and%20soft%20knit%20fabric%20on%20a%20warm%20beige%20background%2C%20hygge%20aesthetic%2C%20soft%20natural%20lighting&width=800&height=500&seq=article-winter-06&orientation=landscape',
    author: '王美琳',
    date: '2026-08-01',
    readTime: '6 分钟',
    tags: ['冬季护肤', '季节护理', '保湿'],
    featured: false,
    content: `
      <h2>冬季皮肤面临的挑战</h2>
      <p>低温、干燥的空气和室内暖气共同构成了冬季皮肤的三重考验。角质层含水量下降、皮脂分泌减少，皮肤屏障功能减弱。这就是为什么冬季更容易出现干燥、脱屑、紧绷和敏感问题。</p>
      
      <h2>策略一：温和清洁升级</h2>
      <p>冬季建议将泡沫洁面换成洁面乳或洁面霜，减少表面活性剂对皮肤的刺激。早晨可以只用温水洗脸，保留夜间分泌的天然油脂来保护肌肤。</p>
      
      <h2>策略二：分层保湿法</h2>
      <p>洗完脸后趁皮肤还微湿时立即涂抹保湿产品。先用质地轻薄的保湿水打底，再叠加含有神经酰胺或角鲨烷的面霜锁水。这种"先水后油"的分层策略能最大化保湿效果。</p>
      
      <h2>策略三：环境湿度管理</h2>
      <p>在卧室和办公室放置加湿器，将环境湿度维持在45%-60%之间。这可能是最简单却最有效的"护肤品"。尤其夜间睡眠期间，充足的湿度能显著减少皮肤水分流失。</p>
    `
  },
  {
    slug: 'hunheji-pifu-jijian-hufu',
    title: '混合肌的极简护肤攻略：T区与U区的平衡之道',
    excerpt: '混合性肌肤的护理难度最高——T区油腻、U区干燥，如何用最少的步骤实现全脸平衡？',
    category: 'jijian-hufu',
    image: 'https://readdy.ai/api/search-image?query=Balanced%20skincare%20for%20combination%20skin%20with%20two%20texture%20zones%20concept%2C%20clean%20minimal%20products%20on%20a%20soft%20cream%20background%2C%20editorial%20style&width=800&height=500&seq=article-combination-07&orientation=landscape',
    author: '林清悦',
    date: '2026-07-28',
    readTime: '5 分钟',
    tags: ['混合肌', '分区护理', '极简护肤'],
    featured: false,
    content: `
      <h2>认识混合肌</h2>
      <p>混合性肌肤是最常见的肤质类型，约占亚洲女性的60%。典型特征是T区（额头、鼻子、下巴）油脂分泌旺盛，而U区（两颊）偏干或正常。这种内在差异决定了混合肌需要"分区护理"的策略。</p>
      
      <h2>极简三步法则</h2>
      <h3>清洁：全脸温和</h3>
      <p>选择氨基酸洁面，全脸使用。不需要为T区单独使用强力清洁产品——过度去油会刺激皮脂腺分泌更多油脂，形成恶性循环。</p>
      
      <h3>保湿：分区对待</h3>
      <p>T区使用清爽的凝胶或乳液，U区使用滋润度更高的面霜。如果觉得两瓶产品太麻烦，可以用同一瓶乳液，在U区叠加薄薄一层保湿精华。</p>
      
      <h3>防晒：全脸一致</h3>
      <p>选择清爽不油腻的防晒产品，全脸使用。物理防晒（氧化锌、二氧化钛）对混合肌更加友好，因为它们本身就有一定的控油效果。</p>
    `
  },
  {
    slug: 'yikeduoyin-chengfen-jiexi',
    title: '依克多因：来自极端环境的皮肤"保护盾"',
    excerpt: '从盐湖和沙漠中发现的依克多因，如何成为敏感肌和受损肌肤的救星？深度解析这一"极端酶"的护肤价值。',
    category: 'chengfen-jiexi',
    image: 'https://readdy.ai/api/search-image?query=Ectoin%20molecule%20skincare%20concept%20with%20crystal%20structures%20and%20natural%20desert%20elements%20on%20a%20light%20beige%20background%2C%20scientific%20aesthetic%2C%20editorial%20photography&width=800&height=500&seq=article-ectoin-08&orientation=landscape',
    author: '陈素心',
    date: '2026-07-25',
    readTime: '7 分钟',
    tags: ['依克多因', '成分解析', '敏感肌'],
    featured: true,
    content: `
      <h2>依克多因的发现之旅</h2>
      <p>依克多因（Ectoin）于1985年首次在埃及盐湖的极端嗜盐菌中被发现。这些微生物能在高盐、高温和强紫外线的极端环境中生存，依克多因就是它们的"保护盾"。</p>
      
      <h2>独特的保护机制</h2>
      <p>依克多因是一种"相容性溶质"，能在细胞周围形成水分子保护层，稳定蛋白质和细胞膜结构。当应用于皮肤时，它能增强皮肤细胞的抗压能力，减少紫外线、干燥和污染物带来的伤害。</p>
      
      <h3>四大护肤功效</h3>
      <p>1. 长效保湿：水分子保护层能持续锁水长达7天；2. 抗光老化：减少UV诱导的细胞损伤；3. 抗污染：阻隔PM2.5等颗粒物的附着；4. 舒缓修护：降低皮肤敏感度，加速屏障修复。</p>
    `
  },
  {
    slug: 'xiaji-qingshuang-hufu',
    title: '夏季清爽护肤：告别油腻的极简三步法',
    excerpt: '夏季高温高湿，皮肤出油加剧。学会这三步极简清爽护肤法，让你的肌肤在盛夏也能自由呼吸。',
    category: 'jijie-hufu',
    image: 'https://readdy.ai/api/search-image?query=Refreshing%20summer%20skincare%20with%20gel%20textures%20and%20citrus%20elements%20on%20a%20light%20blue%20background%2C%20cool%20and%20clean%20aesthetic%2C%20editorial%20photography&width=800&height=500&seq=article-summer-09&orientation=landscape',
    author: '王美琳',
    date: '2026-07-20',
    readTime: '5 分钟',
    tags: ['夏季护肤', '清爽', '控油'],
    featured: false,
    content: `
      <h2>夏季护肤的最大挑战</h2>
      <p>高温环境下，皮脂腺活跃度增加10%，每升高1℃，皮脂分泌量增加约10%。过多的油脂混合汗液和彩妆，容易堵塞毛孔，引发痘痘和粉刺。</p>
      
      <h2>极简三步清爽法</h2>
      <h3>第一步：清爽清洁</h3>
      <p>选择含有水杨酸或葡糖酸锌的洁面产品，早晚各一次。水杨酸能深入毛孔溶解多余油脂，而葡糖酸锌有温和的控油抑菌效果。</p>
      
      <h3>第二步：轻薄保湿</h3>
      <p>将厚重的面霜换成啫喱或凝露质地。含有玻尿酸、甘油等水基保湿成分的产品更适合夏季。油皮甚至可以只用一款保湿精华代替面霜。</p>
      
      <h3>第三步：清爽防晒</h3>
      <p>选择摇摇乐质地的防晒液，清爽不黏腻。含有硅石或玉米淀粉的防晒产品能提供额外的控油效果。记得每2-3小时补涂一次。</p>
    `
  },
  {
    slug: 'suyan-meirong-yinshi',
    title: '素颜也发光：从饮食开始的肌肤养护法则',
    excerpt: '好皮肤七分靠吃三分靠抹。了解哪些食物能帮你养出透亮素颜肌，哪些食物是皮肤的头号敌人。',
    category: 'suyan-jiqiao',
    image: 'https://readdy.ai/api/search-image?query=Healthy%20skincare%20diet%20with%20fresh%20fruits%20vegetables%20and%20nuts%20on%20a%20wooden%20table%2C%20natural%20sunlight%2C%20vibrant%20colors%2C%20editorial%20photography&width=800&height=500&seq=article-diet-10&orientation=landscape',
    author: '林清悦',
    date: '2026-07-18',
    readTime: '6 分钟',
    tags: ['饮食', '素颜', '内调'],
    featured: false,
    content: `
      <h2>皮肤与饮食的关系</h2>
      <p>皮肤是身体最大的器官，也是内在健康的外在反映。研究表明，饮食结构对皮肤状态的影响在4-8周内就会明显显现。吃什么，你的皮肤就会呈现出什么状态。</p>
      
      <h2>养肤食物清单</h2>
      <h3>维生素C丰富的水果</h3>
      <p>猕猴桃、柑橘、草莓等富含维生素C的水果，是胶原蛋白合成的必需营养素。每天摄入200mg维生素C，持续12周可显著改善皮肤弹性和光泽度。</p>
      
      <h3>Omega-3脂肪酸</h3>
      <p>三文鱼、核桃、亚麻籽中的Omega-3能降低皮肤炎症反应，改善干燥和敏感。对于痘痘肌，Omega-3还能调节皮脂分泌。</p>
      
      <h3>抗氧化食物</h3>
      <p>番茄（番茄红素）、绿茶（儿茶素）、蓝莓（花青素）都是强大的抗氧化战士，能中和自由基，延缓皮肤老化。</p>
      
      <h2>皮肤的头号敌人</h2>
      <p>精制糖和高GI食物会引发"糖化反应"，破坏胶原蛋白和弹性蛋白，导致皮肤松弛和皱纹。乳制品对于部分人群可能加重痘痘问题。减少这两类食物的摄入，你的皮肤会感谢你。</p>
    `
  },
];

export const faqs = [
  {
    question: '什么是"全裸护肤"？真的什么都不用吗？',
    answer: '全裸护肤不是什么都不用，而是回归护肤的本质——只使用皮肤真正需要的产品。核心是精简步骤和成分，通常只需清洁、保湿、防晒三步。目标是让皮肤恢复自身的调节和修护能力，而非依赖层层叠叠的外来产品。'
  },
  {
    question: '极简护肤适合所有肤质吗？',
    answer: '是的，极简护肤的理念适用于所有肤质。关键在于根据自身肤质选择合适的少量产品。油性肌肤选择清爽控油产品，干性肌肤选择滋润锁水产品，敏感肌选择修护舒缓产品。精简的是数量，不是质量。'
  },
  {
    question: '从复杂护肤切换到极简护肤，需要多长时间适应？',
    answer: '皮肤适应期通常为2-4周。刚开始减少产品时，可能会感觉皮肤有些不适，这是因为皮肤正在重新学习自我调节。度过这个阶段后，大多数人的皮肤状态会比之前更好、更稳定。建议逐步减少而非一次性全部停用。'
  },
  {
    question: '极简护肤是不是就不用精华和面膜了？',
    answer: '不一定。在基础三步（清洁、保湿、防晒）之外，可以根据皮肤的实际需求选择性使用精华或面膜。例如，干燥季节可以加一款保湿精华，熬夜后可以用一片修护面膜。关键是有针对性而非盲目使用。'
  },
  {
    question: '全裸护肤能改善痘痘吗？',
    answer: '对很多人来说，简化护肤步骤反而能改善痘痘问题。过度清洁和过多产品会破坏皮肤屏障和微生态平衡，导致更多炎症和痘痘。回归温和清洁和基础保湿，给皮肤自我修复的空间，往往能看到明显改善。但如果痘痘严重，建议同时咨询皮肤科医生。'
  },
  {
    question: '防晒真的每天都要涂吗？阴天也要？',
    answer: '是的，防晒是护肤中唯一不可省略的步骤。UVA紫外线全年强度基本不变，能穿透云层和玻璃，是皮肤光老化的主要原因。养成每天涂防晒的习惯，是抗衰老最有效且最经济的方式。建议选择SPF30以上、PA+++的防晒产品。'
  },
];

export const testimonials = [
  {
    name: '小雨',
    age: 28,
    skinType: '混合偏油',
    text: '以前我的护肤桌上堆满了瓶瓶罐罐，皮肤却越来越敏感。自从改为极简三步法，两个月后皮肤竟然变得比以前更稳定了，痘痘也少了！',
    rating: 5,
  },
  {
    name: 'Amanda',
    age: 35,
    skinType: '干性敏感',
    text: '全裸护肤的理念让我重新认识了护肤。以前总觉得涂得多才安心，现在才知道精简才是真正的呵护。皮肤泛红的情况明显改善了。',
    rating: 5,
  },
  {
    name: '小鹿',
    age: 24,
    skinType: '油性痘痘',
    text: '作为一个曾经的"成分党"，我试过各种猛药。后来回归基础三步，配合健康饮食，皮肤反而变得透亮了。少即是多，一点都不假。',
    rating: 4,
  },
  {
    name: 'Grace',
    age: 42,
    skinType: '中性偏干',
    text: '到了40岁，护肤反而越来越简单了。一支温和洁面、一瓶修护面霜、一支防晒，这就是我的全部。皮肤状态比30岁时还好！',
    rating: 5,
  },
];

export const brandInfo = {
  name: '裸肌研究所',
  englishName: 'Bare Skin Lab',
  slogan: '回归本真，唤醒肌肤自愈力',
  description: '裸肌研究所成立于2023年，是一群热爱科学护肤的皮肤科医生、配方师和内容创作者共同打造的专业护肤知识平台。我们致力于传播"全裸护肤"理念——用科学的态度、极简的方法，帮助每个人找到最适合自己的护肤方案。',
  mission: '成为华语世界最值得信赖的极简护肤知识平台，让每一个人都能以科学、理性、简约的方式呵护自己的肌肤。',
  values: [
    { title: '科学为本', description: '所有内容基于经过验证的科研成果，拒绝护肤玄学' },
    { title: '极简主义', description: '倡导精简护肤，用最少的步骤达到最佳效果' },
    { title: '个体定制', description: '尊重每个人的肤质差异，提供个性化护肤建议' },
    { title: '透明真诚', description: '不做夸大宣传，如实呈现护肤的真实效果与局限' },
  ],
  team: [
    { name: '林清悦', role: '联合创始人 / 主笔', description: '北京大学皮肤科学博士，前皮肤科医生，10年临床经验' },
    { name: '陈素心', role: '联合创始人 / 内容总监', description: '化妆品配方师，曾任职于国际知名护肤品牌研发部门' },
    { name: '王美琳', role: '资深编辑', description: '美容媒体从业8年，专注护肤科普写作，文风亲切易懂' },
  ],
  contact: {
    email: 'hello@bareskinlab.com',
    address: '上海市静安区南京西路1266号恒隆广场2座18层',
    phone: '021-6288-XXXX',
  }
};